var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[_vm.b(), { 'om-hairline-top-bottom': _vm.border }]},[(_vm.title)?[_c('div',{class:_vm.b('title')},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_vm._t("default")]:[_vm._t("default")]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ed0103f6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/plugins/jscom/omui/components/cell-group/index.vue
// module id = Mi0Y
// module chunks = 76